export const TOGGLE_PANEL = "TOGGLE_PANEL";
export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
export const SET_SIDEBAR_ITEMS = "SET_SIDEBAR_ITEMS";
export const MENU = "MENU";
export const BREADCRUMBS = "BREADCRUMBS";
export const LOADING = "LOADING";
export const AUTH = "AUTH";
export const API_ERROR = "API_ERROR";
